export const scrollToTop = (firstElement) => {
  if (firstElement && firstElement.current) {
    firstElement.current.scrollIntoView({ behavior: 'auto', block:'end' });
  }
};
